// react-quill-new (Quill 2): react-quill 2.0.0 calls ReactDOM.findDOMNode, which React 19 removed. Its HTML is
// sent through Editor.utils emailHtmlOf (see there).
import ReactQuill from 'react-quill-new';
import { useIntl } from 'react-intl';
import './Editor.scss';

/** The formik `field` of a <Field component={Editor} />. */
interface IEditorProps {
  field: {
    value: string;
    name: string;
    /** formik's handleChange, curried with the field name. */
    onChange: (name: string) => (value: unknown) => void;
  };
}

const Editor = ({ field }: IEditorProps) => {
  const { value, name, onChange } = field;
  const { formatMessage } = useIntl();
  return (
    <div className="editor-container">
      {/* Bug: `formats={Editor.formats}` read a property that was never set, so the editor allows every
          format; the prop is left out, which is the same. */}
      <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange(name)}
        placeholder={formatMessage({ id: 'messages.placeholder_for_editor' })}
        modules={Editor.modules}
      />
    </div>
  );
};

Editor.modules = {
  toolbar: [
    ['bold', 'italic', 'underline'],
    [{ font: [] }],
    [{ size: ['small', false, 'large', 'huge'] }],
    [{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
    [{ list: 'ordered' }, { list: 'bullet' }],
  ],
};

export default Editor;
